module.exports = __webpack_public_path__ + "img/square-selected.67d66393.svg";